import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { FULL_ROLE } from '@utils/helpers'

const logRoutes = {
  path: 'log',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.log'),
  },
  children: [
    {
      path: '',
      name: 'log',
      component: () => lazyLoadView(import('@views/Log/log.vue')),
      meta: {
        authRequired: FULL_ROLE,
      },
    },
  ],
}

export default logRoutes
